import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";

import Client_Comp from "../components/Client_Comp";
import Project_Comp from "../components/Project_Comp";
import Ledger_Due_Comp from "../components/Ledger_Due_Comp";


const Ledger_Due = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  useEffect(() => {
    // Toggle the 'toggle-sidebar' class on the <body> element
    if (isSidebarOpen) {
      document.body.classList.add("toggle-sidebar");
    } else {
      document.body.classList.remove("toggle-sidebar");
    }

    // Cleanup function to remove the class when the component is unmounted or state changes
    return () => {
      document.body.classList.remove("toggle-sidebar");
    };
  }, [isSidebarOpen]);
  return (
    <div>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} />
      {/* <Loader /> */}
      <main id='main' className='main'>
      

        <section className='section'>
          <div className='row'>
            <Ledger_Due_Comp    />
           
          </div>
        </section>
      </main>
      <Footer />
   
    
    

    </div>
  );
};

export default Ledger_Due;
